{
  "version": 1,
  "asset_id": "4800a987-c0b2-4211-8bc0-c80e40fc7ac5",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/4800a987-c0b2-4211-8bc0-c80e40fc7ac5/venue-pool-action.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/4800a987-c0b2-4211-8bc0-c80e40fc7ac5/venue-pool-action.webp",
  "original_filename": "venue-pool-action.webp",
  "size": 99874,
  "content_type": "image/webp",
  "created_at": "2026-07-04T16:13:18Z"
}
